$(document).ready(function(){
  $('.hb-text-imgWrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrow: false,
    dots: false,
    fade: true
  });

  $('.hb-media__content').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrow: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.hb-faqSlider__inner').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrow: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrow: true
        }
      }
    ]
  });
});

$(document).ready(function(){
  var row = $('.feature-row__text');
  var rowW = row.width();
  $('.hb-text-imgWrapper').css('max-width', rowW);
});


// ここから旧サイトのコード
async function addToCart(event) {
  const variantId = event.currentTarget.dataset.id;
  const quantity = parseInt(event.currentTarget.dataset.quantity || "1");

  let directlyGoToCheckout = false;
  let __source;
  const url = window.location.href;

  if (url.includes('pages/lp-334-hb2310')) {
    __source = 'lp-chocolate-hb2310';
  } else if (url.includes('pages/lp-334-hb2409')) {
    __source = 'lp-334-hb2409';
  } else if (url.includes('pages/lp-120-hb2507-a')) {
    __source = 'lp-120-hb2507-a';  
    directlyGoToCheckout = true;       
  } else if (url.includes('pages/lp-sachet-hb2507')) {
    __source = 'lp-sachet-hb2507';    
  } else if (url.includes('pages/lp-120-hb2507')) {
    __source = 'lp-120-hb2507';
    directlyGoToCheckout = true;
  } else if (url.includes('pages/lp-120-hb2603')) {
    __source = 'lp-120-hb2603';
    directlyGoToCheckout = true;    
  } else if (url.includes('pages/lp-120-hb2606')) {
    __source = 'lp-120-hb2606';
    directlyGoToCheckout = true;      
  } else if (url.includes('pages/lp-sachet-line-hb2507')) {
    __source = 'lp-sachet-line-hb2507';     
  } else if (url.includes('pages/lp-120-hb2509')) {
    __source = 'lp-120-hb2509';      
  } else if (url.includes('pages/lp-120-hb2412')) {
    __source = 'lp-120-hb2412';  
    directlyGoToCheckout = true;    
  } else if (url.includes('pages/lp-120-hb2412b')) {
    __source = 'lp-120-hb2412b';    
  } else if (url.includes('pages/lp-120-hb2408')) {
    __source = 'lp-pouch-hb2407';
    directlyGoToCheckout = true;
  } else if (url.includes('pages/lp-265-hb2310')) {
    __source = 'nhs20';    
  } else if (url.includes('pages/lp-265-hb2303')) {
    __source = 'lp-265-hb2303';
  } else if (location.pathname === '/' || location.pathname === '') {
    __source = 'top-page';
    directlyGoToCheckout = true;
  } else {
    console.error('Unsupported URL:', url);
    return;
  }

  const attributes = { __source };
  const properties = { __source };
  const formData = {
    attributes,
    items: [
      {
        id: variantId,
        quantity,
        properties
      }
    ]
  };

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.location.href = directlyGoToCheckout ? "/cart/checkout" : "/cart/";
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

const allButtons = document.querySelectorAll('[data-id]');
allButtons.forEach(button => {
  button.addEventListener('click', addToCart);
});